import _ from '@lodash';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import VizsgazoTableService from '../service/VizsgazoTableService';
import TableToolbarSeparatedXLSButton from '../component/TableToolbarSeparatedXLSButton';
import TableToolbarFullXLSButton from '../component/TableToolbarFullXLSButton';
import TableToolbarDeleteAllButton from '../component/TableToolbarDeleteAllButton';

const config = data => {
	return {
		key: 'vizsgazoTable',
		text: 'Vizsgázók',
		textKey: 'vizsgazo',
		service: VizsgazoTableService,
		editFormState: item => `/vizsgazo/edit/${item ? item.id : 'new'}`,
		toolbarAction: ['filter', 'search', 'refresh'],
		toolbarActionList: [
			{
				text: 'Vizsgázók felvitele',
				icon: 'add',
				action: () => {
					const vizsgaVizsgazo = data.filterList.find(item => item.propertyName === 'vizsgaVizsgazo');
					if (!_.isUndefined(vizsgaVizsgazo)) {
						data.history.push(`/vizsgazo/edit/new/${vizsgaVizsgazo.value}`);
					} else {
						data.dispatch(showMessage({ message: 'Kérem válasszon ki egy vizsgasort a szűrők között.' }));
					}
				}
			},
			{
				component: TableToolbarDeleteAllButton
			},
			{
				component: TableToolbarSeparatedXLSButton
			},
			{
				component: TableToolbarFullXLSButton
			}
		],
		rowAction: ['modify', 'delete'],
		filterFields: [
			{
				text: 'Vizsgasor',
				propertyName: 'vizsgaVizsgazo',
				propertyType: 'Long',
				type: 'EQ'
			}
		],
		columns: [
			{
				key: 'lastLoginTimestamp',
				text: 'Belépés ideje',
				textKey: 'lastLoginTimestamp',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'lockedOnlineExam',
				text: 'Vizsgát befejezte',
				textKey: 'lockedOnlineExam',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'pontszam',
				text: 'Pontszám',
				textKey: 'pontszam',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'erdemjegy',
				text: 'Érdemjegy',
				textKey: 'erdemjegy',
				type: 'text',
				sortable: false,
				disablePadding: false
			},
			{
				key: 'azonosito',
				text: 'Azonosító',
				textKey: 'azonosito',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'vezeteknev',
				text: 'Vezetéknév',
				textKey: 'vezeteknev',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'keresztnev',
				text: 'Keresztnév',
				textKey: 'keresztnev',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'vizsgaHelyeVizsgazo.name',
				text: 'Vizsga helye',
				textKey: 'vizsgaHelyeVizsgazo.name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'vizsgaVizsgazo.name',
				text: 'Vizsga',
				textKey: 'vizsgaVizsgazo.name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'name',
				text: 'Név',
				textKey: 'name',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'email',
				text: 'E-mail',
				textKey: 'email',
				type: 'text',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'bornDate',
				text: 'Születési dátum',
				textKey: 'bornDate',
				type: 'dateTime',
				sortable: true,
				disablePadding: false
			},
			{
				key: 'mothersName',
				text: 'Anyja neve',
				textKey: 'mothersName',
				type: 'text',
				sortable: true,
				disablePadding: false
			}
		]
	};
};

function VizsgazoTable() {
	const dispatch = useDispatch();
	const history = useHistory();
	const filterList = useSelector(rootState => rootState.vizsgazoTable.tableBrowserFilter.filterList);
	const myConfig = config({ filterList, dispatch, history });
	return <TableBrowser config={myConfig} />;
}

export default withReducer('vizsgazoTable', reducer('vizsgazoTable'))(VizsgazoTable);
